@layer module {
.currency-icon-wrapper {
            display: inline-block;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            border-width: 1px;
            border-style: solid;
    }

.currency-icon-wrapper > img {
            display: block;
    }
} // layer module










@layer app {
.currency-icon-wrapper {
            width: $size-30;
            height: $size-30;
            border-radius: $size-5;
    }

.currency-icon-wrapper > img {
            height: 100%;
            width: 100%;
            border-radius: $size-5;
    }

.currency-icon-wrapper.circle {
            border-radius: 50%;
    }

.currency-icon-wrapper.circle > img {
            border-radius: 50%;
    }

.currency-icon-wrapper {
            border-color: var(--border-neutral-light);
    }
} // layer app
